import React from 'react';
import { ServerIcon, UsersIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
export const SystemOverviewWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-2064">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2065">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2066">
          <ServerIcon className="h-5 w-5 text-gray-500 mr-2" data-id="element-2067" />
          System Overview
        </h2>
      </div>
      <div className="p-6" data-id="element-2068">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2069">
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-2070">
            <div className="flex items-center" data-id="element-2071">
              <div className="bg-blue-100 rounded-lg p-2" data-id="element-2072">
                <UsersIcon className="h-6 w-6 text-blue-600" data-id="element-2073" />
              </div>
              <div className="ml-4" data-id="element-2074">
                <p className="text-sm text-gray-500" data-id="element-2075">Active Users</p>
                <p className="text-xl font-bold text-gray-900" data-id="element-2076">237</p>
                <p className="text-xs text-green-600" data-id="element-2077">24 currently online</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-2078">
            <div className="flex items-center" data-id="element-2079">
              <div className="bg-green-100 rounded-lg p-2" data-id="element-2080">
                <CheckCircleIcon className="h-6 w-6 text-green-600" data-id="element-2081" />
              </div>
              <div className="ml-4" data-id="element-2082">
                <p className="text-sm text-gray-500" data-id="element-2083">Successful Jobs</p>
                <p className="text-xl font-bold text-gray-900" data-id="element-2084">98.2%</p>
                <p className="text-xs text-green-600" data-id="element-2085">Last 24 hours</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-2086">
            <div className="flex items-center" data-id="element-2087">
              <div className="bg-red-100 rounded-lg p-2" data-id="element-2088">
                <XCircleIcon className="h-6 w-6 text-red-600" data-id="element-2089" />
              </div>
              <div className="ml-4" data-id="element-2090">
                <p className="text-sm text-gray-500" data-id="element-2091">Failed Jobs</p>
                <p className="text-xl font-bold text-gray-900" data-id="element-2092">3</p>
                <p className="text-xs text-red-600" data-id="element-2093">Requires attention</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6" data-id="element-2094">
          <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-2095">
            Recent System Activity
          </h3>
          <div className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-2096">
            <div className="divide-y divide-gray-200" data-id="element-2097">
              <div className="px-4 py-3" data-id="element-2098">
                <p className="text-sm text-gray-900" data-id="element-2099">
                  Automated Bill Generation
                </p>
                <div className="flex items-center mt-1" data-id="element-2100">
                  <span className="h-2 w-2 bg-green-500 rounded-full" data-id="element-2101"></span>
                  <span className="text-xs text-gray-500 ml-2" data-id="element-2102">
                    Completed successfully at 02:15 AM
                  </span>
                </div>
              </div>
              <div className="px-4 py-3" data-id="element-2103">
                <p className="text-sm text-gray-900" data-id="element-2104">Database Backup</p>
                <div className="flex items-center mt-1" data-id="element-2105">
                  <span className="h-2 w-2 bg-green-500 rounded-full" data-id="element-2106"></span>
                  <span className="text-xs text-gray-500 ml-2" data-id="element-2107">
                    Completed successfully at 01:00 AM
                  </span>
                </div>
              </div>
              <div className="px-4 py-3" data-id="element-2108">
                <p className="text-sm text-gray-900" data-id="element-2109">
                  Email Notification Service
                </p>
                <div className="flex items-center mt-1" data-id="element-2110">
                  <span className="h-2 w-2 bg-red-500 rounded-full" data-id="element-2111"></span>
                  <span className="text-xs text-gray-500 ml-2" data-id="element-2112">
                    Failed at 11:45 PM - SMTP connection error
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 py-3 bg-gray-50 border-t border-gray-200" data-id="element-2113">
        <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-800" data-id="element-2114">
          View system logs
        </a>
      </div>
    </div>;
};